<template>
  <div class="row bg-akdemica p-5">
    <div class="col-12">
      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="50" class="mr-2">
        <img src="../../assets/img/white/tipografia.png" height="35">
      </div>
    </div>

    <div class="col-12 col-md-4">
      <p class="text-white text-light" style="font-size:22px">A Akdemcia é a plataforma completa de cursos online para professores e alunos</p>
    </div>

    <div class="col-12 col-md-3 text-white">
      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="20" class="mr-2">
        <h6 class="mb-0"><b>SOBRE</b></h6>
      </div>

      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="20" class="mr-2">
        <h6 class="mb-0"><b>COMUNIDADE</b></h6>
      </div>

      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="20" class="mr-2">
        <h6 class="mb-0"><b>CURSOS</b></h6>
      </div>
    </div>

    <div class="col-12 col-md-3 text-white">
      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="20" class="mr-2">
        <h6 class="mb-0"><b>PRECISA DE AJUDA?</b></h6>
      </div>
      <p class="text-white text-light mb-1 ml-4" style="font-size:15px">SUPORTE</p>
      <p class="text-white text-light mb-1 ml-4" style="font-size:15px">TUTORIAIS E PERGUNTAS FREQUENTES</p>

    </div>

    <div class="col-12 col-md-2 text-white">
      <div class="w-100 d-flex justify-content-start align-items-center mb-3">
        <img src="../../assets/img/white/logo-simples.png" height="20" class="mr-2">
        <h6 class="mb-0"><b>NOS SIGA</b></h6>
      </div>
      <ul class="nav">
        <li class="nav-item mr-3" ><i class="fab fa-2x fa-instagram"></i></li>
        <li class="nav-item" ><i class="fab fa-2x fa-facebook-f"></i></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
